import { render, staticRenderFns } from "./SupplierProfitDashboard.vue?vue&type=template&id=69431aec&scoped=true&"
import script from "./SupplierProfitDashboard.vue?vue&type=script&lang=js&"
export * from "./SupplierProfitDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SupplierProfitDashboard.vue?vue&type=style&index=0&id=69431aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69431aec",
  null
  
)

export default component.exports